import _defineProperty from "/workdir/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

/* eslint-disable react/no-multi-comp */
import React, { Component, Fragment } from 'react';
import Icon from "@scentregroup/ui/components/icon";
import classNames from 'classnames';
import analyticsUtils from '../../helpers/analytics-utils';
import { getBrowser, isMobile } from '../../helpers/get-browser';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export let Theme;

(function (Theme) {
  Theme["Parking"] = "parking";
})(Theme || (Theme = {}));

var InteractionKind;

(function (InteractionKind) {
  InteractionKind["Touch"] = "Touch";
  InteractionKind["Click"] = "Click";
})(InteractionKind || (InteractionKind = {}));

const InfoAccordionRowContent = ({
  content
}) => /*#__PURE__*/_jsxs(React.Fragment, {
  children: [/*#__PURE__*/_jsx("div", {
    className: style.parkingContent,
    children: content
  }), /*#__PURE__*/_jsx("span", {
    className: style.accordionBorder
  })]
});

const InfoAccordionRow = ({
  title,
  content,
  extraHeight = false,
  rowBorder,
  theme
}) => /*#__PURE__*/_jsxs(React.Fragment, {
  children: [/*#__PURE__*/_jsxs("h3", {
    className: classNames([style.accordionRow, extraHeight && style.extraHeight]),
    children: [title && /*#__PURE__*/_jsx("span", {
      className: style.rowTitle,
      children: title
    }), content && /*#__PURE__*/_jsx("span", {
      className: classNames(style.rowContent, {
        [style.parking]: theme === 'parking'
      }),
      children: content
    })]
  }), /*#__PURE__*/_jsx("span", {
    className: rowBorder
  })]
});

const AccordionHeading = ({
  toggleHandler,
  isExpanded,
  expandTitle,
  rowBorder,
  theme
}) => {
  const {
    opened,
    closed
  } = typeof expandTitle === 'string' ? {
    opened: expandTitle,
    closed: expandTitle
  } : expandTitle;
  let content = isExpanded ? opened : closed;
  let start = 0;
  /* 
    The duration for a Click is 125 milliseconds
    The duration for a Long(Press/Touch) is 500 milliseconds
  */

  const longPressDuration = 500;

  if (typeof content === 'string') {
    content = /*#__PURE__*/_jsx("h2", {
      children: content
    });
  }

  const hideBorder = theme === 'parking' && isExpanded;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsxs("h3", {
      className: style.headerHeading,
      children: [/*#__PURE__*/_jsx(Icon, {
        type: isExpanded ? 'chevron-up' : 'chevron-down',
        className: classNames(style.expandButton, {
          [style.parking]: theme === 'parking'
        })
      }), /*#__PURE__*/_jsx("button", {
        className: style.btnOveride,
        type: "button",
        "aria-expanded": isExpanded,
        onClick: () => toggleHandler(InteractionKind.Click),
        onTouchStart: () => {
          start = new Date().getTime();
        },
        onTouchEnd: () => {
          const newDate = new Date();
          const touchDuration = newDate.getTime() - start; // Disables the touch if durations is <= 500 milliseconds

          if (touchDuration <= longPressDuration) {
            toggleHandler(InteractionKind.Touch);
          }
        },
        children: /*#__PURE__*/_jsx(InfoAccordionRow, {
          theme: theme,
          content: content
        })
      })]
    }), !hideBorder && /*#__PURE__*/_jsx("span", {
      className: rowBorder
    })]
  });
};

class InfoAccordionWrapper extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      isExpanded: false
    });
  }

  toggleHandler(interactionKind) {
    const deviceMobile = isMobile(getBrowser(this.context));
    const {
      Touch,
      Click
    } = InteractionKind;
    const touchAndMobile = interactionKind === Touch && deviceMobile;
    const clickAndDesktop = interactionKind === Click && !deviceMobile;

    if (touchAndMobile || clickAndDesktop) {
      this.toggleRow();
    }
  }

  toggleRow() {
    const {
      isExpanded
    } = this.state;
    this.setState({
      isExpanded: !isExpanded
    });
    analyticsUtils.gaTagTracking({
      event: analyticsUtils.events.USER_CLICK,
      eventCategory: analyticsUtils.categories.EVENT_DETAILS_INTERACTION,
      eventLabel: isExpanded ? analyticsUtils.actions.LESS : analyticsUtils.actions.MORE
    });
  }

  render() {
    const {
      isExpanded
    } = this.state;
    const {
      metaRow,
      theme
    } = this.props;
    const rows = !metaRow.expandTitle || isExpanded ? metaRow.rows : [];
    const isOcc = metaRow.rowType === 'occurrence';
    const {
      accordionBorder,
      indentBorder
    } = style;
    const rowBorder = isOcc && rows.length === 1 || theme === 'parking' ? accordionBorder : "".concat(indentBorder, " ").concat(accordionBorder);
    return /*#__PURE__*/_jsxs("li", {
      children: [metaRow.expandTitle && /*#__PURE__*/_jsx(AccordionHeading, {
        toggleHandler: interactionKind => this.toggleHandler(interactionKind),
        expandTitle: metaRow.expandTitle,
        isExpanded: isExpanded,
        rowBorder: isExpanded ? rowBorder : accordionBorder,
        theme: theme
      }), rows.map((row, inx) => {
        if (theme === 'parking') {
          return /*#__PURE__*/_jsx(InfoAccordionRowContent, {
            content: row.content
          }, inx);
        }

        return /*#__PURE__*/_jsx(InfoAccordionRow, {
          title: row.title,
          content: row.content,
          extraHeight: isOcc,
          rowBorder: rows.length - 1 === inx ? accordionBorder : rowBorder
        }, inx);
      })]
    });
  }

}

const InfoAccordion = ({
  metaRows,
  purpose,
  theme
}) => /*#__PURE__*/_jsx("ul", {
  className: classNames(style.infoAccordionWrapper, {
    [style.parking]: theme === 'parking'
  }),
  "aria-label": purpose,
  "aria-level": 2,
  role: "heading",
  children: metaRows.map((x, inx) => /*#__PURE__*/_jsx(InfoAccordionWrapper, {
    metaRow: x,
    theme: theme
  }, inx))
});

export default InfoAccordion;